import type { Bike } from 'models/shared';

export const GENERATION_DISCLAIMER =
  'Fitment expanded by MX Locker using model-year generation data. Confirm compatibility for your specific part before purchasing.';

export function splitGenerationDisclaimer(disclaimer = '') {
  const hasGenerationDisclaimer = disclaimer.includes(GENERATION_DISCLAIMER);
  return {
    hasGenerationDisclaimer,
    mainDisclaimer: disclaimer.replace(GENERATION_DISCLAIMER, '').trim(),
  };
}

export function removedOriginalFitments(original: Bike[], current: Bike[]) {
  const key = (bike: Bike) =>
    JSON.stringify([bike.make, bike.model, bike.year]);
  const currentKeys = new Set(current.map(key));
  return original.filter((bike) => !currentKeys.has(key(bike)));
}

export function groupFitmentYears(bikes: Bike[]) {
  const groups = new Map<
    string,
    { make: string; model: string | null; years: Set<number | null> }
  >();
  for (const bike of bikes) {
    const key = JSON.stringify([bike.make, bike.model]);
    const group = groups.get(key) ?? {
      make: bike.make,
      model: bike.model,
      years: new Set<number | null>(),
    };
    group.years.add(bike.year);
    groups.set(key, group);
  }
  return [...groups.values()]
    .map(({ make, model, years }) => ({
      label: `${make} ${model ?? '(model unspecified)'}`,
      years: [...years]
        .sort((a, b) => (a ?? 0) - (b ?? 0))
        .map((year) => year ?? 'Year unspecified')
        .join(', '),
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
